export const SET_CONTACT = 'SET_CONTACT';

export function setContact(payload) {
  return {
    type: SET_CONTACT,
    payload,
  };
}
